/*门诊诊疗打印模板*/
export const outpatientsDiagnosis = {
    panels: [
        {
            index: 0,
            paperType: "A4",
            height: 297,
            width: 210,
            paperHeader: 118.5,
            paperFooter: 889.5,
            printElements: [
                {
                    options: {
                        left: 106.5,
                        top: -15,
                        height: 9.75,
                        width: 120
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 12,
                        top: 9,
                        height: 808.5,
                        width: 570
                    },
                    printElementType: {
                        type: "rect"
                    }
                },
                {
                    options: {
                        left: 22.5,
                        top: 12,
                        height: 30,
                        width: 225,
                        title: "医院名称",
                        fontSize: 12,
                        lineHeight: 15,
                        field: "clinicName"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 261,
                        top: 12,
                        height: 30,
                        width: 331.5,
                        title: "统一社会信用代码",
                        fontSize: 12,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 75,
                        top: 25.5,
                        height: 9,
                        width: 157.5
                    },
                    printElementType: {
                        type: "hline"
                    }
                },
                {
                    options: {
                        left: 142.5,
                        top: 51,
                        height: 42,
                        width: 310.5,
                        title: "门(急)诊诊疗信息页",
                        fontSize: 21.75,
                        letterSpacing: 9,
                        lineHeight: 17.25
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 49.5,
                        top: 94.5,
                        height: 21,
                        width: 540,
                        title: "就诊卡号/病案号",
                        field: "seeDoctorId",
                        fontSize: 12,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 201,
                        top: 136.5,
                        height: 22.5,
                        width: 106.5,
                        title: "性别",
                        field: "sex",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 316.5,
                        top: 136.5,
                        height: 22.5,
                        width: 267,
                        title: "出生日期",
                        field: "brdy",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 15,
                        top: 136.5,
                        height: 22.5,
                        width: 175.5,
                        title: "姓名",
                        field: "name",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 16.5,
                        top: 175.5,
                        height: 21,
                        width: 222,
                        title: "证件号",
                        field: "certNo",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 348,
                        top: 175.5,
                        height: 21,
                        width: 115.5,
                        title: "民族",
                        fontSize: 15,
                        lineHeight: 15,
                        field: "naty"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 468,
                        top: 175.5,
                        height: 21,
                        width: 114,
                        title: "婚姻状态",
                        fontSize: 15,
                        lineHeight: 15,
                        field: "mrgState"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 246,
                        top: 175.5,
                        height: 21,
                        width: 97.5,
                        title: "国籍",
                        fontSize: 15,
                        lineHeight: 15,
                        field: "ntlyId"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 15,
                        top: 210,
                        height: 22.5,
                        width: 570,
                        title: "现住址",
                        fontSize: 15,
                        lineHeight: 15,
                        field: "conerAddName"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 15,
                        top: 247.5,
                        height: 22.5,
                        width: 174,
                        title: "联系电话",
                        field: "tel",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 15,
                        top: 285,
                        height: 22.5,
                        width: 570,
                        title: "药物或其他过敏史",
                        field: "phrAlgsDrugAiseId",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 15,
                        top: 321,
                        height: 22.5,
                        width: 570,
                        title: "挂号时间",
                        fontSize: 15,
                        lineHeight: 15,
                        field: "regTime"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 15,
                        top: 358.5,
                        height: 22.5,
                        width: 570,
                        title: "报到时间",
                        fontSize: 15,
                        lineHeight: 15,
                        field: "seeDoctorTime"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 15,
                        top: 393,
                        height: 22.5,
                        width: 570,
                        title: "就诊时间",
                        fontSize: 15,
                        lineHeight: 15,
                        field: "seeDoctorTime"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 196.5,
                        top: 429,
                        height: 22.5,
                        width: 159,
                        title: "接诊医生",
                        fontSize: 15,
                        lineHeight: 15,
                        field: "doctorName"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 364.5,
                        top: 429,
                        height: 22.5,
                        width: 219,
                        title: "接诊医生职称",
                        fontSize: 15,
                        lineHeight: 15,
                        field: "professionalTitle"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 15,
                        top: 429,
                        height: 22.5,
                        width: 174,
                        title: "就诊科室",
                        fontSize: 15,
                        lineHeight: 15,
                        field: "deptName"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 99,
                        top: 472.5,
                        height: 21,
                        width: 28.5,
                        fontSize: 15,
                        lineHeight: 15,
                        field: "repeated"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 141,
                        top: 472.5,
                        height: 21,
                        width: 441,
                        title: "1.急诊 2.普通门诊 3.特需门诊 4.互联网诊疗 5.MDT门诊 9.其他",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 15,
                        top: 472.5,
                        height: 21,
                        width: 72,
                        title: "是否复诊:",
                        testData: "是",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 99,
                        top: 508.5,
                        height: 21,
                        width: 28.5,
                        fontSize: 15,
                        lineHeight: 15,
                        field: "infusion"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 141,
                        top: 508.5,
                        height: 21,
                        width: 441,
                        title: "1.是 2.否",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 15,
                        top: 508.5,
                        height: 21,
                        width: 72,
                        title: "是否输液:",
                        testData: "否",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 187.5,
                        top: 546,
                        height: 19.5,
                        width: 28.5,
                        fontSize: 15,
                        lineHeight: 15,
                        field: "chronicSpecial"
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 231,
                        top: 546,
                        height: 19.5,
                        width: 351,
                        title: "1.是 2.否",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 15,
                        top: 546,
                        height: 19.5,
                        width: 162,
                        title: "是否为门诊慢特病患者:",
                        testData: "否",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 138,
                        top: 582,
                        height: 19.5,
                        width: 28.5,
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 187.5,
                        top: 582,
                        height: 19.5,
                        width: 391.5,
                        title: "1.I 级 2.II级 3.III级 4.IV级",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 15,
                        top: 582,
                        height: 21,
                        width: 111,
                        title: "急诊患者分级:",
                        testData: "三级",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 16.5,
                        top: 621,
                        height: 21,
                        width: 111,
                        title: "急诊患者去向:",
                        testData: "门诊治疗",
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 138,
                        top: 622.5,
                        height: 21,
                        width: 28.5,
                        fontSize: 15,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 15,
                        top: 663,
                        height: 90,
                        width: 573,
                        title: "1.医嘱离院 2.医嘱转院 3.医嘱转社区卫生服务机构/乡镇卫生院 4.非医嘱离院 5.死亡 6.急诊留观 7.急诊转入院 9.其他",
                        fontSize: 15,
                        letterSpacing: 3.75,
                        lineHeight: 15
                    },
                    printElementType: {
                        type: "text"
                    }
                },
                {
                    options: {
                        left: 16.5,
                        top: 760.5,
                        height: 42,
                        width: 570,
                        title: "住院证开具时间",
                        fontSize: 16.5,
                        lineHeight: 15,
                        field: "createTime"
                    },
                    printElementType: {
                        type: "text"
                    }
                }
            ],
            paperNumberLeft: 565.5,
            paperNumberTop: 819,
            paperNumberDisabled: true
        }
    ]
}